





















import Vue, { PropType } from "vue";
import { adaptHealthPocView } from "@/utils/healthPocViewAdapter";

type HealthPocMetric = ReturnType<typeof adaptHealthPocView>["sections"][number]["metrics"][number];

export default Vue.extend({
  name: "HealthMetricCard",
  props: {
    metric: { type: Object as PropType<HealthPocMetric>, required: true },
    icon: { type: String, default: "heart" },
    tone: { type: String, default: "blue" },
    valueLabel: { type: String, required: true },
    unitLabel: { type: String, default: "" },
    caption: { type: String, required: true }
  }
});
